// Replacements for native window.alert / confirm / prompt — async, themed,
// match the app's .modal-back / .modal-box / .btn / .btn-primary styles.

function escapeAttr(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function escapeText(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export type ConfirmOpts = {
  title: string;
  body?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
};

export function modalConfirm(opts: ConfirmOpts): Promise<boolean> {
  return new Promise((resolve) => {
    const back = document.createElement('div');
    back.className = 'modal-back';
    back.innerHTML = `
      <div class="modal-box">
        <h2>${escapeText(opts.title)}</h2>
        ${opts.body ? `<p style="white-space:pre-wrap;">${escapeText(opts.body)}</p>` : ''}
        <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;">
          <button id="mc-no" class="btn">${escapeText(opts.cancelLabel ?? 'Cancel')}</button>
          <button id="mc-yes" class="btn ${opts.danger ? '' : 'btn-primary'}"
            ${opts.danger ? 'style="color:#fff;background:#E25C5C;border-color:#E25C5C;"' : ''}>${escapeText(opts.confirmLabel ?? 'Confirm')}</button>
        </div>
      </div>
    `;
    document.body.appendChild(back);
    const done = (v: boolean) => { back.remove(); resolve(v); };
    document.getElementById('mc-no')!.addEventListener('click', () => done(false));
    document.getElementById('mc-yes')!.addEventListener('click', () => done(true));
    back.addEventListener('click', (e) => { if (e.target === back) done(false); });
  });
}

export function modalAlert(opts: { title: string; body?: string; okLabel?: string }): Promise<void> {
  return new Promise((resolve) => {
    const back = document.createElement('div');
    back.className = 'modal-back';
    back.innerHTML = `
      <div class="modal-box">
        <h2>${escapeText(opts.title)}</h2>
        ${opts.body ? `<p style="white-space:pre-wrap;">${escapeText(opts.body)}</p>` : ''}
        <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;">
          <button id="ma-ok" class="btn btn-primary">${escapeText(opts.okLabel ?? 'OK')}</button>
        </div>
      </div>
    `;
    document.body.appendChild(back);
    const done = () => { back.remove(); resolve(); };
    document.getElementById('ma-ok')!.addEventListener('click', done);
    back.addEventListener('click', (e) => { if (e.target === back) done(); });
  });
}

export type PromptOpts = {
  title: string;
  body?: string;
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  confirmLabel?: string;
};

export function modalPrompt(opts: PromptOpts): Promise<string | null> {
  return new Promise((resolve) => {
    const back = document.createElement('div');
    back.className = 'modal-back';
    back.innerHTML = `
      <div class="modal-box">
        <h2>${escapeText(opts.title)}</h2>
        ${opts.body ? `<p style="white-space:pre-wrap;">${escapeText(opts.body)}</p>` : ''}
        <label class="small" style="display:block;margin-top:8px;">
          ${opts.label ? escapeText(opts.label) : ''}
          <input id="mp-input" type="text" value="${escapeAttr(opts.defaultValue ?? '')}"
            placeholder="${escapeAttr(opts.placeholder ?? '')}"
            style="display:block;width:100%;margin-top:4px;padding:8px 10px;background:var(--bg-3);border:1px solid var(--line);border-radius:6px;color:var(--ink);font-size:14px;" />
        </label>
        <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;">
          <button id="mp-cancel" class="btn">Cancel</button>
          <button id="mp-ok" class="btn btn-primary">${escapeText(opts.confirmLabel ?? 'OK')}</button>
        </div>
      </div>
    `;
    document.body.appendChild(back);
    const inp = document.getElementById('mp-input') as HTMLInputElement;
    const done = (v: string | null) => { back.remove(); resolve(v); };
    document.getElementById('mp-cancel')!.addEventListener('click', () => done(null));
    document.getElementById('mp-ok')!.addEventListener('click', () => done(inp.value.trim() || null));
    inp.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') done(inp.value.trim() || null);
      if (e.key === 'Escape') done(null);
    });
    back.addEventListener('click', (e) => { if (e.target === back) done(null); });
    setTimeout(() => { inp.focus(); inp.select(); }, 30);
  });
}
